import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setFabMessage, clearFabMessage } from "../features/layout/helpFabSlice";
import rules from "../components/GlobalHelpFAB/messages.json";

function normalize(p) {
    if (!p) return "/";
    return p.length > 1 && p.endsWith("/") ? p.slice(0, -1) : p;
}

function findRule(pathname) {
    const path = normalize(pathname);
    if (rules[path]) return rules[path];
}

export default function useRouteHelpFab() {
    const { pathname } = useLocation();
    const dispatch = useDispatch();

    const matched = useMemo(() => findRule(pathname), [pathname]);

    useEffect(() => {
        if (matched) {
            dispatch(
                setFabMessage({
                    title: matched.titleKey,
                    message: matched.messageKey,
                    whatsappText: matched.whatsappText || "Hello, I have a question about this page.",
                })
            );
        } else {
            dispatch(clearFabMessage());
        }
    }, [matched, dispatch]);
}
